import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, switchMap, of, Observable, take, map } from 'rxjs';
import { AdminAuthService } from '../services/admin/admin-auth.service';

@Injectable({ providedIn: 'root' })
export class AdminPermission {
  private _auth = inject(AdminAuthService);
  private _msalService = inject(MsalService);
  private _broadCast = inject(MsalBroadcastService);
  private _router = inject(Router);

  canActivate(): Observable<boolean | UrlTree> {
    return this._broadCast.inProgress$.pipe(
      filter((status) => status === InteractionStatus.None),
      take(1),
      switchMap(() =>
        this._auth.isAuthenticated$.pipe(
          take(1),
          map((isAuthenticated) =>
            isAuthenticated ? true : this._router.parseUrl('/admin/login')
          )
        )
      )
    );
  }
}

export const msalGuard: CanActivateFn = () =>
  inject(AdminPermission).canActivate();
